var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('base-section',{staticClass:"lightgrey",attrs:{"id":"vizionhome","space":"0"}},[_c('div',{staticStyle:{"text-align":"center"}},[_vm._v(" Vizion Home Page "),_c('router-view')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }